<template>
  <form class="recover">
    <File
      :chosenFileName="chosenFileName"
      @submitMedia="submitMedia"
      @deleteFile="deleteFile"
    />
    <inputText
      label="В каком деле вы мастер?"
      :field="text"
      size="lg"
      name="master"
      @input="text = $event"
      type="text"
      maxlength="16"
      :class="{ error: validationStatus($v.text) || errorMessage.text }"
      :error="
        (!$v.text.required && $v.text.$error
          ? 'Обязательное поле'
          : !$v.text.maxLength && $v.text.$error
          ? 'Максимум ' + $v.text.$params.maxLength.max + ' символов'
          : '') || errorMessage.text
      "
    />

    <div class="recover__footer">
      <button
        type="button"
        class="btn btn--primary w-100"
        @click="submit()"
        :class="{ loading: submitStatus == 'PENDING' }"
      >
        сделать коллаж<img
          src="../../assets/img/spinner.svg"
          class="loader"
          alt=""
        />
      </button>
    </div>
  </form>
</template>

<script>
import inputText from "@/components/form/inputText.vue";
import File from "./inputFile.vue";

import { required, maxLength } from "vuelidate/lib/validators";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  name: "RecoverForm",
  data() {
    return {
      ready: false,
      index: 1,
      text: "Мастер ",
      attach: "",
      errorMessage: {
        text: null,
      },

      submitStatus: null,
      chosenFileName: {},
    };
  },

  validations: {
    text: { required, maxLength: maxLength(16),  },
  },

  methods: {
    submitMedia(e) {
      // let t = this;

      this.chosenFileName = e;
      console.log(e[0]);
      this.attach = e[0];
      // if (this.chosenFileName.length) {
      //   getBase64(this.chosenFileName[0]).then(function (data) {
      //     t.attach = data;
      //   });
      // }
    },

    deleteFile() {
      this.chosenFileName = {};
      this.attach = "";
    },

    errorReset() {
      this.$v.$reset();

      this.errorMessage = {
        text: null,
      };
    },

    validationStatus: function (validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },

    submit() {
      this.$v.$touch();

      if (this.$v.$pendding || this.$v.$error) return;

      if (this.submitStatus !== "PENDING") {
        this.submitStatus = "PENDING";
        const formData = new FormData();

        formData.append('file', this.attach);
        formData.append('master', this.text);
        const data = {
          fields: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        };
        this.$store
          .dispatch("AddPhoto", data)
          .then((r) => {
            if (!r.result) {
              this.submitStatus = null;

              let fieldsError = null;

              if (r.error && r.error.master) {
                [this.errorMessage.text] = r.error.master;
                fieldsError = true;
              }


              if (r.error && !fieldsError) {
                this.$modal.hide("upload_photo");
                this.$modal.show("common_error", {
                  title: r.error,
                });
              }
              if(r.code === 100) {
                this.$modal.hide("upload_photo");
                this.$modal.show("common_error_upload", {
                  text: r.error,
                });
              }
            } else {
              this.submitStatus = null;

              this.$modal.hide("upload_photo");
              this.$modal.show("common_success", {
                title: 'добавление фото',
                text: 'Ваш коллаж обрабатывается',
                btnClose: true,
              });
              this.gtmEvent("photo_success", "do", "internal");
              this.$store.dispatch("GetCodes", { page: 1 });
            }
          })
          .catch(() => {
            this.submitStatus = null;
          });
      }
    },
  },
  mounted() {
  },
  components: {
    inputText,
    File
  },
};
</script>

<style lang="scss">
.recover {
  &__footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: rem(35px);
    text-align: center;
  }
  .btn {
    margin-bottom: rem(15px);
  }
}
</style>
